// src/icons/ApiConnection.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function ApiConnection() {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "22",
      height: "18",
      viewBox: "0 0 22 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1 8H0V10H1V8ZM21 10H22V8H21V10ZM11 16C7.13401 16 4 12.866 4 9H2C2 13.9706 6.02944 18 11 18V16ZM4 9C4 5.13401 7.13401 2 11 2V0C6.02944 0 2 4.02944 2 9H4ZM14 9C14 10.6569 12.6569 12 11 12V14C13.7614 14 16 11.7614 16 9H14ZM11 12C9.34315 12 8 10.6569 8 9H6C6 11.7614 8.23858 14 11 14V12ZM8 9C8 7.34315 9.34315 6 11 6V4C8.23858 4 6 6.23858 6 9H8ZM11 6C12.6569 6 14 7.34315 14 9H16C16 6.23858 13.7614 4 11 4V6ZM3 8H1V10H3V8ZM11 2C13.9361 2 16.4524 3.80802 17.4915 6.37522L19.3454 5.62478C18.011 2.32832 14.7786 0 11 0V2ZM17.5628 11.4413C16.5714 14.1051 14.0058 16 11 16V18C14.8681 18 18.1639 15.5602 19.4372 12.1389L17.5628 11.4413ZM15 10H21V8H15V10Z",
          fill: "currentColor"
        }
      )
    }
  );
}

export {
  ApiConnection
};
